var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Project } from '@/models/Project';
import Chat from '@/components/chat/Chat';
import { User } from '@/models/User';
import { RolesEnum } from '@/items/Roles';
let Messenger = class Messenger extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.chatUserModel = new User().filter({ roles: [RolesEnum.TEACHER] });
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get chatRoom() {
        return this.project && this.project.chat && this.project.chat.default || '';
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Messenger.prototype, "project", void 0);
Messenger = __decorate([
    Component({
        components: {
            Chat,
        },
    })
], Messenger);
export default Messenger;
